import { render, staticRenderFns } from "./awtzhfls.vue?vue&type=template&id=4cdc3e3a&"
import script from "./awtzhfls.vue?vue&type=script&lang=js&"
export * from "./awtzhfls.vue?vue&type=script&lang=js&"
import style0 from "./awtzhfls.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports